export default __webpack_public_path__ + "static/media/dog_v1.230b0266.png";